import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { CategoriesProvider } from './context/CategoriesContext';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import ForgotPassword from './components/auth/ForgotPassword';
import ResetPassword from './components/auth/ResetPassword';
import GmailSetup from './components/auth/GmailSetup';
import TodoApp from './components/TodoApp';
import Settings from './components/settings/Settings';
import ProtectedRoute from './components/layout/ProtectedRoute';
import './App.css';

const AppRoutes = () => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600 mx-auto"></div>
          <p className="mt-4 text-gray-600">Loading...</p>
        </div>
      </div>
    );
  }

  return (
    <Routes>
      <Route path="/login" element={
        user ? <Navigate to="/" /> : <Login />
      } />
      <Route path="/register" element={
        user ? <Navigate to="/" /> : <Register />
      } />
      <Route path="/forgot-password" element={
        user ? <Navigate to="/" /> : <ForgotPassword />
      } />
      <Route path="/reset-password/:token" element={
        user ? <Navigate to="/" /> : <ResetPassword />
      } />
      <Route path="/gmail-setup" element={
        <ProtectedRoute>
          <CategoriesProvider>
            <GmailSetup />
          </CategoriesProvider>
        </ProtectedRoute>
      } />
      <Route path="/settings" element={
        <ProtectedRoute>
          <CategoriesProvider>
            <Settings />
          </CategoriesProvider>
        </ProtectedRoute>
      } />
      <Route path="/" element={
        <ProtectedRoute>
          <CategoriesProvider>
            <TodoApp />
          </CategoriesProvider>
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <AppRoutes />
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;
